import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from "react";
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";
import { alcyoneContactInformation, lusisContactInformation } from "../../../utils/contactInformation";
import { getInitials } from "../../../utils/getInitials";

export default function EuropassPdfHeader( { resumeData, translations } ) {

    const { user } = extractResumeDataDocumentSection( resumeData );
    const { isAnonymous, isAlcyone } = extractResumeProperties( resumeData );
    const europassLogoSrc = "/europass-cv.png";

    const { phoneNumber, emailAddress, webSite, postalAddress } = isAlcyone
        ? alcyoneContactInformation
        : lusisContactInformation;

    const styles = StyleSheet.create( {
        headerContainer: {
            height: 100,
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            marginLeft: -20,
            marginTop: -20
        },
        user: {
            fontSize: 16,
            fontWeight: 'bold',
            color: "#565656",
            paddingLeft: "20px",
            marginTop: 20,
        },
        header: {
            width: 150,
            alignSelf: 'flex-end',
            position: 'absolute',
            top: 22,
            right: 25,
        },
        textHeader: {
            fontWeight: 'bold',
            fontSize: 8,
        },
        lineEuropass: {
            height: 1,
            backgroundColor: "#979797",
            marginLeft: 20,
            marginTop: 15,
            marginRight: 10,
        },
        imageEuropass: {
            width: 120,
            height: 24,
            objectFit: 'contain',
        },
    } );

    return (
        <View style={ styles.headerContainer }>
            <Text style={ styles.user }>
                { isAnonymous
                    ? getInitials( user.firstName ) + ' ' + getInitials( user.lastName, true )
                    : user.firstName + ' ' + user.lastName }
            </Text>
            <View style={ styles.header } fixed>
                <Image style={ styles.imageEuropass } src={ europassLogoSrc }/>
            </View>
            <View style={ styles.lineEuropass }/>
            <View style={ {
                display: "flex",
                flexDirection: "row",
                gap: 5,
                flexWrap: "wrap",
                marginLeft: 20,
                marginTop: 10
            } }>
                <Text style={ styles.textHeader }>
                    { translations.pdf.phoneNumberLabel }{ ' ' }
                    <Text style={ { fontWeight: 'normal' } }>{ phoneNumber }</Text>
                </Text>
                <Text style={ styles.textHeader }>
                    { translations.pdf.emailAddressLabel }{ ' ' }
                    <Text style={ { fontWeight: 'normal' } }>{ emailAddress }</Text>
                </Text>
                <Text style={ styles.textHeader }>
                    { translations.pdf.webSiteLabel }{ ' ' }
                    <Text style={ { fontWeight: 'normal' } }>{ webSite }</Text>
                </Text>
                <Text style={ styles.textHeader }>
                    { translations.pdf.postalAddressLabel }{ ' ' }
                    <Text style={ { fontWeight: 'normal' } }>{ postalAddress }</Text>
                </Text>
            </View>
        </View>
    );
}
